var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-30" }, [
    _vm.title
      ? _c("div", { staticClass: "section-title" }, [
          _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
          _c("hr")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.loader
      ? _c("div", { staticClass: "swiper-container" }, [
          _c("div", [_vm._v("Buscando sugestão de horários")]),
          _vm._v(" "),
          _c("img", { attrs: { src: "/static/loader.svg", width: "150px" } })
        ])
      : !_vm.loader &&
        (_vm.availableEvents === null || !_vm.availableEvents.length)
        ? _c("div", { staticClass: "style-info" }, [
            _vm._v(
              "Não encontramos profissionais disponíveis próximo a data escolhida."
            )
          ])
        : _c(
            "div",
            [
              _c("div", { staticClass: "style-info" }, [
                _vm._v(
                  "Selecione um dos horários sugeridos para ajustar a duração da limpeza"
                )
              ]),
              _vm._v(" "),
              _c(
                "swiper",
                { attrs: { options: _vm.swiperOption } },
                [
                  _vm._l(_vm.availableEvents, function(event, index) {
                    return _c("swiper-slide", { key: index + "-event" }, [
                      _c(
                        "div",
                        {
                          staticClass: "event",
                          class: { selected: _vm.selectedEvent === event },
                          on: {
                            click: function($event) {
                              _vm.selectAvailableEvent(event)
                            }
                          }
                        },
                        [
                          _c("b", { staticClass: "text-purple" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatDate")(event.starts_at, "DD/MM")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("b", [
                            _c("small", { staticClass: "text-purple" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatDate")(event.starts_at, "dddd")
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("small", [
                            _vm._v(
                              "\n            das\n            " +
                                _vm._s(
                                  _vm._f("formatDate")(
                                    event.starts_at,
                                    "HH[hrs]"
                                  )
                                ) +
                                "\n            às\n            " +
                                _vm._s(
                                  _vm._f("formatDate")(event.ends_at, "HH[hrs]")
                                ) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    ])
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "swiper-button-prev prev",
                    attrs: { slot: "button-prev" },
                    slot: "button-prev"
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "swiper-button-next next",
                    attrs: { slot: "button-next" },
                    slot: "button-next"
                  })
                ],
                2
              )
            ],
            1
          )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b7ac5d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b7ac5d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Steps/ProfessionalsSuggestion.vue
// module id = null
// module chunks = 